import { render, staticRenderFns } from "./NavListItem.vue?vue&type=template&id=4833bd98&"
import script from "./NavListItem.vue?vue&type=script&lang=js&"
export * from "./NavListItem.vue?vue&type=script&lang=js&"
import style0 from "./NavListItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem,VListItemIcon,VListItemTitle})
